import moment from "moment";
import "./MapStyle.css";
import useFavorites from "../../../utils/useFavorites";
import { useDispatch } from "react-redux";
import {
  setSingleProgramId,
  setActiveOnglet,
  addOpenProgram,
} from "../../../redux/actions/immobilierActions";

const ProgramCard = ({
  listeDesProgrammes,
  setPosition,
  selectedProgramId,
  setSelectedProgramId,
}) => {
  const dispatch = useDispatch();
  const { favorites, isProgramInFavorites, handleAddToFavorites } =
    useFavorites();
    
  const handleProgramDoubleClick = (programId) => {
    dispatch(addOpenProgram(programId));
    dispatch(setSingleProgramId(programId));
    dispatch(setActiveOnglet(`programme-${programId}`));
  };

  return (
    <div className="d-flex flex-wrap gap20">
      {listeDesProgrammes &&
        listeDesProgrammes.map((programme) => (
          <div
            key={programme.documentId}
            className={`programCard d-flex w100 bg-white radius5 gap20 p-2 pointer ${
              selectedProgramId === programme.documentId ? "selected" : ""
            }`}
            onClick={() => {
              const imageUrl =
                programme.lots[0]?.images[0]?.origine_url ||
                "./assets/imgNotFound.webp";
              setPosition({
                lng: programme.longitude,
                lat: programme.latitude,
                image: imageUrl,
              });
              setSelectedProgramId(programme.documentId);
            }}
            onDoubleClick={() => handleProgramDoubleClick(programme.documentId)}
          >
            <img
              src={
                programme.lots[0]?.images[0]?.origine_url ||
                "./assets/imgNotFound.webp"
              }
              alt="appart"
              className="radius5 w40"
            />

            <div className="w100 d-flex flex-column justify-content-between">
              <div>
                <div className="d-flex justify-content-between">
                  <div className="d-flex flex-column gap10 ">
                    <p className="semibold fs21 darkGrey">{programme.name}</p>
                    <p className="darkGrey fs16 regular">
                      {programme.promoteur.name}
                    </p>
                    <p className="darkGrey fs16 semibold">
                      {programme.address || "Municipalité"}
                    </p>
                  </div>
                  <div className="d-flex flex-column text-end ">
                    <p className="darkGrey fs11 regular">
                      TVA {programme.TVA || "NC"}
                    </p>
                    <p className="darkGrey fs18 semibold mb-10">
                      <p className="fs11 regular"> à partir de</p>
                      {Intl.NumberFormat("fr-FR").format(
                        programme?.lots[0]?.price_total
                      ) + "€" || "NC"}
                    </p>
                    <p className="darkGrey fs11 regular">
                      Hono. {programme.honoraires || "NC"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="separator my-2"></div>

              <div className="d-flex justify-content-between ">
                <div className=" d-flex gap10 flex-wrap align-items-center">
                  {/*   <span className="bg-softer-grey p-1 white radius18 py-2  px-3">
                    {programme.type || "T1"}
                  </span>
                  <span className="bg-softer-grey p-1 white radius18 py-2 px-3">
                    {programme.surface || "NC"}
                  </span>
                  <span className="bg-softer-grey p-1 white radius18 py-2 px-3">
                    {programme.etage || "NC"} Étage
                  </span>
                  <span className="bg-pink p-1 white radius5 p-2">
                    {programme.ptz || "NC"}
                  </span>
                  <span className="bg-oyster p-1 white radius5 p-2">
                    {programme.pinel || "NC"}
                  </span> */}
                  <img
                    src={
                      isProgramInFavorites(programme.documentId)
                        ? "./icons/favorite-filled.svg"
                        : "./icons/favorite-outline.svg"
                    }
                    alt="favorite"
                    height={35}
                    width={35}
                    className=""
                    onClick={(e) => {
                      e.stopPropagation();
                      handleAddToFavorites(programme.documentId, "Programme");
                    }}
                  />
                </div>
                <div className="d-flex  gap-3 ">
                  <div>
                    <p className="darkGrey fs11 regular">Actabilité :</p>
                    <p className="darkGrey fs16 semibold mb-20">
                      {programme.is_actable ? "Immédiate" : "Pas Précisé"}
                    </p>
                  </div>
                  <div>
                    {" "}
                    <p className="darkGrey fs11 regular">Livraison :</p>
                    <p className="darkGrey fs16 semibold">
                      {programme.delivery_date
                        ? moment(programme.delivery_date).format("YYYY") +
                          " T-" +
                          moment(programme.delivery_date).quarter()
                        : "NC"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
    </div>
  );
};

export default ProgramCard;
